import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

const KEYS = ["residential", "deep", "move", "office", "post_reno", "window", "garden", "airbnb"];
const CUSTOM_QUOTE_KEYS = new Set(["office", "window", "garden"]);

export default function Services() {
  const { t } = useTranslation();
  return (
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24">
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#5BA83F]">{t("services_page.eyebrow")}</p>
      <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#1B3A6B] mt-3 tracking-tight max-w-3xl">{t("services_page.title")}</h1>
      <p className="mt-5 text-lg text-slate-600 max-w-2xl leading-relaxed">{t("services_page.intro")}</p>
      <div className="mt-12 grid md:grid-cols-2 gap-5">
        {KEYS.map((k) => {
          const isCustom = CUSTOM_QUOTE_KEYS.has(k);
          return (
            <div key={k} className="bg-white rounded-xl p-6 ring-1 ring-slate-200 hover:shadow-md hover:ring-[#1B3A6B]/20 transition-all" data-testid={`services-page-${k}`}>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#5BA83F]/10 flex items-center justify-center text-[#3F7A1F] shrink-0"><Sparkles className="w-5 h-5" /></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-heading font-semibold text-lg text-[#0F172A]">{t(`services.${k}`)}</h3>
                    {isCustom && <span className="text-[10px] uppercase tracking-wide font-bold text-amber-700 bg-amber-50 ring-1 ring-amber-200 px-1.5 py-0.5 rounded-full">{t("book_page.custom_quote_badge")}</span>}
                  </div>
                  <p className="mt-1 text-sm text-slate-600 leading-relaxed">{t(`services_page.long_desc.${k}`)}</p>
                  {isCustom && (
                    <div className="mt-3 flex flex-wrap gap-2">
                      <Link to="/quote"><Button size="sm" className="bg-[#1B3A6B] hover:bg-[#152D54] text-white rounded-full" data-testid={`services-cta-quote-${k}`}>{t("book_page.go_request_quote")}</Button></Link>
                      <a href={`https://wa.me/31642449019?text=${encodeURIComponent("Hi Trustline, I'd like a quote for " + t(`services.${k}`) + ".")}`} target="_blank" rel="noreferrer">
                        <Button size="sm" variant="outline" className="rounded-full" data-testid={`services-cta-whatsapp-${k}`}>{t("book_page.message_whatsapp")}</Button>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-14 flex flex-wrap gap-3">
        <Link to="/quote"><Button size="lg" className="bg-[#1B3A6B] hover:bg-[#152D54] text-white rounded-full px-7 h-12">{t("services_page.cta_quote")}</Button></Link>
        <Link to="/contact"><Button size="lg" variant="outline" className="rounded-full px-7 h-12">{t("services_page.cta_talk")}</Button></Link>
      </div>
    </div>
  );
}
